<template>
  <ul :class="listClass">
    <li
      v-for="(item, index) in items"
      :key="`${item.text}-${index}`"
      :class="itemClass"
    >
      {{ item.text }}
      <BulletList
        v-if="item.children?.length"
        :items="item.children"
        list-class="nested-list"
        item-class="nested-item"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'BulletList',
  props: {
    items: {
      type: Array,
      required: true,
    },
    listClass: {
      type: String,
      default: '',
    },
    itemClass: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 0.5rem 0;
  padding-left: 1.5rem;
  position: relative;
}

li::before {
  content: "→";
  position: absolute;
  left: 0;
  color: #4ec9b0;
}

.nested-list {
  margin-top: 0.35rem;
}

.nested-item::before {
  content: "·";
  color: #9cdcfe;
}

.result-item::before {
  content: "★";
  color: #dcdcaa;
}
</style>
